import { Outlet } from "react-router-dom";
import {
  Spacer,
  Stack,
  StackDirection,
  useBreakpointValue,
} from "@chakra-ui/react";

import NavigationTabsBar from "components/NavigationTabs";
import CustomerSelect from "components/CustomerSelect";
import { mobileStyleBreakpoint } from "util/styleHelpers";

const NAV_STACK_DIRECTION = mobileStyleBreakpoint<StackDirection>(
  "column-reverse",
  "row"
);

const NavigationLayout = () => {
  const stackDirection = useBreakpointValue(NAV_STACK_DIRECTION, {
    ssr: false,
  });
  return (
    <>
      <Stack direction={stackDirection}>
        <NavigationTabsBar />
        <Spacer />
        <CustomerSelect />
      </Stack>
      <Outlet />
    </>
  );
};

export default NavigationLayout;
